import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { curriculumendpoints } from "../apis";

const {  GET_CURRICULUM_BY_CLASS_API , GET_CURRICULUM_BY_CLASS_ADMIN_API} = curriculumendpoints;

export function fetchCurriculumByClass() {
  const token = JSON.parse(localStorage.getItem("token"));
  return async () => {
    //const toastId = toast.loading("Loading curriculum...");
    try {
      const response = await apiConnector(
        "GET",
        GET_CURRICULUM_BY_CLASS_API,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      // Return the data directly
      return response.data.data;
    } catch (error) {
      console.log("FETCH_CURRICULUM_API ERROR............", error);
      toast.error("Could not load curriculum data.");
      return null; // Return null on error
    } finally {
      // toast.dismiss(toastId);
    }
  };
}

export function fetchCurriculumByClassAdmin(className) {
  // console.log("clanme",className)
  //  console.log("api",GET_CURRICULUM_BY_CLASS_ADMIN_API)
  const token = JSON.parse(localStorage.getItem("token"));
  return async () => {
    //const toastId = toast.loading("Loading curriculum...");
    try {
      const response = await apiConnector(
        "POST",
        GET_CURRICULUM_BY_CLASS_ADMIN_API,
        {className},
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
     // console.log("res",response)

      // Return the data directly
      return response.data.data;
    } catch (error) {
      console.log("FETCH_CURRICULUM_API ERROR............", error);
      toast.error("Could not load curriculum data.");
      return null; // Return null on error
    } finally {
      // toast.dismiss(toastId);
    }
  };
}
